export const defaultMeta = {
  current_page: 1,
  current_page_size: 1,
  total: 1,
  total_pages: 1,
};
